<template lang="pug">
  table#tbInventariosFisicos.table.is-responsive.is-striped.is-narrow
    thead
      tr
        th(colspan=2 align="center") Producto Recibido
    tbody
      tr
        td(align="center")
          span.tag.is-light.is-size-6.has-text-weight-medium  Programa LPG Ducto
        td(align="center") 
          span.tag.is-black.is-size-6.has-text-weight-medium {{ getUltimoEnvio(data) | numberFormatDecimal }} T.M.
      tr
        td(align="center")
          span.tag.is-light.is-size-6.has-text-weight-medium  Total recibido durante el mes
        td(align="center")
          span.tag.is-black.is-size-6.has-text-weight-medium {{ getTotalMasa(data) | numberFormatDecimal }} T.M.
</template>

<script>
  import Decimal from 'decimal.js'
  export default {
    name: 'TbProductoRecibido',
    props: {
      data: {
        type: Array,
        default: [],
      },
    },
    methods: {
      getTotalMasa(envios) {
        if (envios.length > 0) {
          let totalMes = 0
          totalMes = envios.reduce( (total, d ) => {
            const masa = new Decimal(d.fqi_diff)
            total = new Decimal(total || 0).plus(masa)
            return total.toFixed(2)
          }, 0)
          return totalMes
        } else {
          return 0
        }
      },

      getUltimoEnvio(envios) {
        if (envios.length > 0) {
          const countE = envios.length - 1
          const result = new Decimal(envios[countE].fqi_diff)
          return result.toFixed(2)
        } else {
          return 0
        }
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/irge/dashboard/componentes/Tb_ProductoRecibido.vue